export default function CsharpUserInput() {
  return (
    <h2>Csharp User Input</h2>
  );
}
